export default "__VITE_ASSET__CAUt5Fry__"